import { createContext, useState, useContext, useEffect } from 'react';
import { useCookies } from 'react-cookie';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [cookies, setCookie] = useCookies(['refresh', 'encrypted_key']);
  const [refresh, setRefresh] = useState(cookies.refresh || false);
  const [encrypted_key, setEncrypted_key] = useState('');

  useEffect(() => {
    if (refresh) {
      setCookie('refresh', refresh, { path: '/' });
    }
    if (encrypted_key) {
      setCookie('encrypted_key', encrypted_key, { path: '/' });
    }
  }, [refresh, encrypted_key, setCookie]);

  const refreshPage = (refresh) => {
    console.log('refresh');
    setRefresh(refresh);
  };

  const setUserData = (encrypted_key) => {
    setEncrypted_key(encrypted_key);
  };

  const clearUserData = () => {
    setEncrypted_key(encrypted_key);
  };

  return (
    <UserContext.Provider
      value={{
        refresh,
        encrypted_key,
        refreshPage,
        setRefresh,
        setUserData,
        clearUserData
      }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
